import React, { Component } from 'react';
import {
	Card,
	Row,
	Col,
	FormControl,
	FormGroup,
	FormLabel,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
	Accordion as PrimeAccordion,
	AccordionTab,
} from 'primereact/accordion';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale } from 'react-datepicker';
import Spinner from '@atlaskit/spinner';

import LoadingButton from '../../components/LoadingButton';
import api from '../../api';
import { withUser } from '../../modules/User';
import Grid from '../../components/Grid';

import canceledOrdersColumnsDef from './canceledOrdersColumnsDef';
import './styles.scss';

/*
  <Duplicates
    duplicatas={duplicatas}
  />
*/

registerLocale('ptBR', ptBR);

const INITIAL_STATE = {
	// Canceled orders
	canceledOrders: [],
	shadowCanceledOrders: null,

	// Filters
	// representante: '', // removido para não limpar representante ao rodar handleCLear
	searchedRepresentante: '',
	// searchedSupervisor: [],
	// suggestionPriority: '',

	// Page State
	isLoading: false,
	isSending: false,
	activeIndex: 0,
};

class CanceledOrders extends Component {
	state = {
		...INITIAL_STATE,
		representante: this.props.userProps
			? this.props.userProps.representativeId
			: '',
	};

	// Lifecycle
	componentDidUpdate() {
		// Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
		// Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
		// Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
		// Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
		// E então, seta o representante no estado
		if (this.props.userProps) {
			const { representativeId } = this.props.userProps;
			if (
				(representativeId || representativeId === 0) &&
				!this.state.representante &&
				this.state.representante !== 0
			) {
				this.setState({ representante: representativeId });
			}
		}
	}

	// Handlers

	handleActiveIndex = (activeIndex) => this.setState({ activeIndex });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Input" da tela, para melhorar a
	 * visualização do código.
	 */
	handleFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Date" da tela, para melhorar a
	 * visualização do código.
	 */

	handleClear = () =>
		this.setState({
			...INITIAL_STATE,
			tabAtual: this.state.tabAtual,
			articlesOptions: this.state.articlesOptions,
			articlesSelected: this.state.articlesOptions,
		});

	// Request

	handleGetCanceledOrders = async () => {
		const { representante, searchedRepresentante } = this.state;
		const params = {
			representativeId:
				representante === 0 ? searchedRepresentante : representante,
		};
		this.setState({ isLoading: true, canceledOrders: [] });
		try {
			const { data: canceledOrders } =
				await api.comercial.canceledOrders.getCanceledOrders({
					params: params,
				});

			this.setState({ canceledOrders });
		} catch (err) {
			toast.error(`Erro ao consultar Ordens Canceladas: ${err.message}`);
		} finally {
			this.setState({ isLoading: false, activeIndex: null });
		}
	};

	render() {
		const {
			// Duplicates
			canceledOrders,

			// Filters
			representante,
			searchedRepresentante,
			// searchedSupervisor,
			// suggestionPriority,

			// Page State
			isLoading,
			// isSending,
			activeIndex,
		} = this.state;

		if (representante === '')
			return (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			);

		return (
			<>
				<div className="acompVendas-container">
					<PrimeAccordion
						activeIndex={activeIndex}
						onTabChange={(e) => this.handleActiveIndex(e.index)}
						style={{ marginBottom: '0.8vh' }}
					>
						<AccordionTab header="Filtros">
							<Row>
								{representante === 0 && (
									<Col md={3}>
										<FormGroup>
											<FormLabel>Representante</FormLabel>
											<FormControl
												style={{ marginBottom: '20px' }}
												className="rounded-input"
												type="text"
												name="searchedRepresentante"
												value={searchedRepresentante}
												onChange={this.handleFieldChange}
												disabled={representante !== 0}
											/>
										</FormGroup>
									</Col>
								)}
								<Col md={3}>
									<div className="actions">
										<FormGroup style={{ marginTop: '29px' }}>
											<ButtonGroup>
												{
													<LoadingButton
														type="button"
														variant="success"
														title="Consultar"
														onClick={this.handleGetCanceledOrders}
														isLoading={isLoading}
													>
														{Button}
													</LoadingButton>
												}
												{
													<Button
														className="btn btn-secondary"
														onClick={this.handleClear}
													>
														Limpar
													</Button>
												}
											</ButtonGroup>
										</FormGroup>
									</div>
								</Col>
							</Row>
						</AccordionTab>
					</PrimeAccordion>
				</div>
				<Card className="card-indicadores">
					<Card.Body className="align-items-center">
						<div className="canceledOrders-styles">
							<Grid
								reflectShadowRows={(shadowCanceledOrders) =>
									this.setState({ shadowCanceledOrders })
								}
								data={canceledOrders}
								minHeight={400}
								rawColumnsDef={canceledOrdersColumnsDef}
								rowHeight={20}
								headerRowHeight={20}
								enableSummary
								highlightActiveRow
							/>
						</div>
					</Card.Body>
				</Card>
			</>
		);
	}
}

export default withUser(CanceledOrders);
